import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import HeroSection from "../../Components/HeroSection";
import OurMission from "../../Components/OurMission";
import Testimonials from "../../Components/Testimonials";
import { useLocation } from "react-router-dom";
import KEYWORDS from "../../Constants/keywords";


import {
  ProjectCarousal, 
  Services, 
  Products, 
  WhatWeOffer,
  AboutUs,
  WhyChooseVirtuosoft,
  ClientLogoSection,
  AIMLSection, 
  FinTechSection
} from "../../Components/Version2";



const Section = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 20px 40px;
  @media screen and (max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 56px;
  }
`;

const LandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    
    const sectionId = location.hash.substring(1);
    if (sectionId) {
      scrollToSection(sectionId);
    }
  }, [location.hash]);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth"  });
    }
  };
  return (
    <>
      <Helmet>
        <meta name="keywords" content={KEYWORDS.home.join(", ")} />
      </Helmet>
      <HeroSection />
      <Section id="ai">
        <AIMLSection />
      </Section>
      <Section id="fintech">
        <FinTechSection />
      </Section>
      <Section id="projects">
        <ProjectCarousal />
      </Section>
      <Section id="services">
        <Services />
      </Section>
      <Section id="products">
        <Products />
      </Section>
      <Section id="expertise">
        <WhatWeOffer />
      </Section>
      <Section id="about-us">
        <AboutUs />
      </Section>
      <Section id="">
        <WhyChooseVirtuosoft />
      </Section>
      <Section id="">
        <ClientLogoSection />
      </Section>
      <Section>
        <Testimonials />
      </Section>
      <Section>
        <OurMission />
      </Section>
    </>
  );
};

export default LandingPage;
